var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTelegram = function SvgTelegram(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.77 1.561L.47 7.854a.206.206 0 00-.028.013c-.133.075-1.055.637.246 1.142l.013.005 3.882 1.25a.215.215 0 00.179-.021l9.628-5.992a.212.212 0 01.077-.029c.134-.022.52-.063.276.246-.276.35-6.853 6.229-7.582 6.88a.22.22 0 00-.073.147l-.319 3.787a.248.248 0 00.1.199.242.242 0 00.287-.022l2.306-2.056a.214.214 0 01.269-.014l4.023 2.915.013.008c.098.06 1.15.67 1.453-.693l2.778-13.173c.004-.042.041-.5-.287-.771-.346-.284-.834-.14-.908-.125a.21.21 0 00-.032.011z",
    fill: "currentColor"
  })));
};
export default SvgTelegram;